import { Component } from '@angular/core';

@Component({
  selector: 'app-annule-retour-frns',
  templateUrl: './annule-retour-frns.component.html',
  styleUrls: ['./annule-retour-frns.component.scss'],
})
export class AnnuleRetourFrnsComponent {}
